import React, { useEffect, useState } from "react";
import { BadgePercent, Truck, X } from "lucide-react";
import { waLink } from "../lib/execora";

export const EarlyMemberOfferPopup = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = window.setTimeout(() => setVisible(true), 700);
    return () => window.clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (!visible) return undefined;

    const onKeyDown = (event) => {
      if (event.key === "Escape") {
        setVisible(false);
      }
    };

    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [visible]);

  if (!visible) return null;

  return (
    <div
      className="fixed inset-0 z-[80] flex items-center justify-center px-4 py-6"
      role="dialog"
      aria-modal="true"
      aria-labelledby="early-member-offer-title"
      data-testid="early-member-offer-popup"
    >
      <button
        type="button"
        className="absolute inset-0 bg-slate-950/45 backdrop-blur-sm"
        aria-label="Close early member offer"
        onClick={() => setVisible(false)}
      />

      <div className="relative w-full max-w-[420px] overflow-hidden rounded-[1.75rem] border border-slate-200/80 bg-white shadow-[0_24px_70px_-24px_rgba(15,23,42,0.5)]">
        <div className="h-1.5 bg-[#84cc15]" aria-hidden="true" />
        <div className="absolute -right-24 -top-20 h-56 w-56 rounded-full bg-[#84cc15]/15 blur-3xl" aria-hidden="true" />
        <div className="absolute -bottom-28 -left-20 h-56 w-56 rounded-full bg-slate-900/5 blur-3xl" aria-hidden="true" />

        <div className="relative px-6 pb-6 pt-5 sm:px-7 sm:pb-7">
          <div className="flex items-center justify-between gap-4">
            <div className="inline-flex items-center gap-2 rounded-full border border-[#84cc15]/25 bg-[#f7fee7] px-3 py-1.5 text-[11px] font-bold uppercase tracking-[0.14em] text-[#65a30d]">
              <BadgePercent className="h-3.5 w-3.5" strokeWidth={2.2} />
              Early member offer
            </div>
            <button
              type="button"
              className="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-slate-200 bg-white text-slate-500 shadow-sm transition-colors hover:bg-slate-50 hover:text-slate-900"
              aria-label="Close offer popup"
              onClick={() => setVisible(false)}
            >
              <X className="h-4 w-4" strokeWidth={2.2} />
            </button>
          </div>

          <div className="mt-7">
            <h2
              id="early-member-offer-title"
              className="font-display text-4xl font-extrabold leading-tight tracking-tight text-slate-950 sm:text-[2.75rem]"
            >
              Free delivery
            </h2>
            <p className="mt-2 inline-flex rounded-full bg-slate-100 px-3 py-1 text-sm font-bold text-slate-900">
              on your first order
            </p>
            <p className="mt-4 text-sm leading-6 text-slate-600">
              Explore everything your neighbourhood has to offer through Execora.
            </p>
          </div>

          <a
            href={waLink("Hi Execora, I want to claim the free delivery offer on my first order.")}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-7 inline-flex w-full items-center justify-center gap-2 rounded-2xl bg-[#84cc15] px-5 py-3.5 text-sm font-bold text-white shadow-[0_14px_32px_-12px_rgba(132,204,21,0.9)] transition-colors hover:bg-[#65a30d]"
          >
            <Truck className="h-4 w-4" strokeWidth={2.3} />
            Claim free delivery
          </a>
        </div>
      </div>
    </div>
  );
};

export default EarlyMemberOfferPopup;